// import Image from "next/image";
import styles from "../styles/Home.module.css";
// import Head from "next/head";
import UnitListings from "../../../components/UnitListings";
import Page from "../../../components/Page";
// import { Roboto } from "next/font/google";
import { useEffect } from "react";

import ClassCalendar from "../../../components/ClassCalendar";

export default function Units() {
    useEffect(() => {
        document.title = "Math With Maki | Calendar"
    }, []);

    const rawPage: string = window.location.pathname.split("/")[1];
    const page: string | null =
        rawPage === "math150"
            ? "calc"
            : rawPage === "math254"
            ? "lindisc"
            : "calc";

    

    return (
        <>
            <head>
                <title>Math with Maki</title>
                <meta name="description" content="Math with Maki" />
                <link rel="icon" href="/favicon.ico" />
            </head>
            <Page href="math150" style={{ width: "100%", height: "100%" }}>
                {/* <h2>Calendar</h2> */}
                <ClassCalendar page={page} isAdmin={false} />
            </Page>
        </>
    );
}
